module.exports = __webpack_public_path__ + "9603852819a8dedf0d785058a978ac86.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/resources/users.svg
// module id = 4074
// module chunks = 0